/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoice_AccruedInputs */

const cs_billing_invoice_accrued = /** @type {(inputs: Billing_Invoice_AccruedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na faktuře`)
};

const en_billing_invoice_accrued = /** @type {(inputs: Billing_Invoice_AccruedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice accrued`)
};

/**
* | output |
* | --- |
* | "Invoice accrued" |
*
* @param {Billing_Invoice_AccruedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_invoice_accrued = /** @type {((inputs?: Billing_Invoice_AccruedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoice_AccruedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_invoice_accrued(inputs)
	return cs_billing_invoice_accrued(inputs)
});